<script setup lang="ts">
    import { __ } from '../../stores/expressions';
    import TextInput, { TextInputWidth } from '../TextInput.vue';
    import RolesTable from './RolesTable.vue';
    import { useRolesTableData } from '@/js/stores/roles-table';
    import { SearchIcon } from '@lucide/vue';

    const table = useRolesTableData();
</script>

<template>
    <div class="flex gap-10 items-center pb-12">
        <TextInput
            v-model="table.search"
            :width="TextInputWidth.Large"
            :placeholder="__('roles-list-search-placeholder')"
        >
            <template #end-adornment><SearchIcon /></template>
        </TextInput>
    </div>
    <RolesTable />
</template>
